import { useMemo } from "react";

import { GqlMapEditorGetLayerAllFeaturesParams } from "~/__generated__";

import { useLayerVisibility } from "./useLayerVisibility";
import { useMapFilters } from "./useMapFilters";

type UseMapEditorFilterParamsOptions = {
    visitIds?: string[];
};

export function useMapEditorFilterParams({
    visitIds,
}: UseMapEditorFilterParamsOptions = {}): GqlMapEditorGetLayerAllFeaturesParams {
    const { filters } = useMapFilters();
    const { visibleLayerIds, showAllLayersByDefault } = useLayerVisibility();

    return useMemo(() => {
        return {
            ecologicalFunctionTypeIds: filters.ecologicalFunctionTypeIds,
            observationTypeIds: filters.observationTypeIds,
            protocolVisitIds: filters.protocolVisitIds,
            researchTypeIds: filters.researchType?.map(x => x.researchTypeId),
            speciesIds: filters.researchType?.map(x => x.speciesId),
            layerIds: showAllLayersByDefault ? undefined : visibleLayerIds,
            visitIds,
        };
    }, [filters, showAllLayersByDefault, visibleLayerIds, visitIds]);
}
